export default __webpack_public_path__ + "static/media/paco.863b424c.svg";